﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as bootstrap_switch from 'bootstrap-switch';

import config from '../../../common/config';

import tpl_schemaScreen from './tpl/schemaScreen.html';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';

var schema = require('../../helper/schemaScreen');

import View_Module from './module';

import View_ModuleItem from './moduleItem';

export default View_ModuleItem.extend({
    getTemplate: function () {
        return tpl_schemaScreen();
    },
    regions: {
        'modal': '#modal'
    },
    playLive: function () {
    },
    initialize: function () {
        var self = this;
        this.app = this.options.app;

        this.listenTo(this.model, 'setupSetting', this.setupSetting, this);

        var userChannel = Backbone.Radio.channel('app');
        this.listenTo(userChannel, 'schemaScreen:EVENT_SCHEMAREFRESH', function () {
            self.setupSetting();
        });

        this.timerId = -1;

        this.listenTo(this.model, 'change', this.render, this);

        /*window.event4us = {};
        window.event4us.event = {};
        window.event4us.event.schema = {};
        window.event4us.event.schemaBigscreen = {};*/
    },
    ui: {
        'setting_margin': '#setting_margin',
        'module_margin': '#module_margin',
        'schemaScreen_schemaScreen': '#schemaScreen_schemaScreen',
        'schemaScreen_margin': '#schemaScreen_margin',
        'schemaData': '#schemaData'
    },
    events: {
    },
    onRender: function () {
        this.setupSetting();
    },
    setupSetting() {
        this.setupMargin();

        if (this.timerId != -1) clearTimeout(this.timerId);

        var self = this;
        this.callback = function (SchemaRefreshInterval, timerId) {
            self.SchemaRefreshInterval = SchemaRefreshInterval;
            self.timerId = timerId;
            //self.refreshSchema();

            self.SchemaRefreshTimerId = window.setInterval(function () {
                self.refreshSchema();
            }, SchemaRefreshInterval * 60000); 
        }

        //this.ui.marquee.css('font-family', this.model.attributes.Data.Font);
        //this.ui.marquee.css('font-size', this.model.attributes.Data.Font_Size);

        //if (window.event4us.event.schema.schemaModelId > 0) {
        this.tables = [];
        schema.schema_init(this.options.customEvent.attributes.id,//window.event4us.event.eventId,
            config.webApiUrl(),
            this.options.customEvent.attributes.id,//window.event4us.event.schema.schemaModelId,
            this.ui.schemaData,
            true,
            'da-DK', this.tables,
            this.model,
            this.app,
            this.callback);
        //}


    },
    onAttach() {
        //this.setupSetting();
    },
    refreshSchema: function () {
        var self = this;

        if (this.SchemaRefreshTimerId != -1) {
            clearTimeout(this.SchemaRefreshTimerId);
        }

        if (this.timerId != -1) { 
            clearTimeout(this.timerId);
        }
        
        this.tables = [];
        schema.schema_init(this.options.customEvent.attributes.id,//window.event4us.event.eventId,
            config.webApiUrl(),
            this.options.customEvent.attributes.id,//window.event4us.event.schema.schemaModelId,
            this.ui.schemaData,
            true,
            'da-DK', this.tables,
            this.model,
            this.app,
            this.callback);
    //}

        //if (self.SchemaRefreshInterval > 0) {
        //    self.timeoutId = setTimeout(function () {
        //        self.refreshSchema();
        //    }, self.SchemaRefreshInterval * 60000);
        //}
    },
    //onDestroy: function () {
    //    $('*[data-css="schema_css"]').remove();

    //    this.tables.forEach(function (entry) {
    //        entry.clear();
    //    });

    //    clearTimeout(this.timeoutId);
    //},
    myDestroy: function () {
        $('*[data-css="schema_css"]').remove();

        this.tables.forEach(function (entry) {
            entry.clear();
        });

        if (this.SchemaRefreshTimerId) {
            clearTimeout(this.SchemaRefreshTimerId);
        }

        if (this.timerId != -1) clearTimeout(this.timerId);
    }
}, Backbone.Radio.Requests);
